const DIGIT_MAP: Record<string, string> = { '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4', '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9', '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };

export function toEnglishDigits(value: unknown): string {
  return String(value ?? '').replace(/[۰-۹٠-٩]/g, (digit) => DIGIT_MAP[digit]);
}

export function groupDigits(value: unknown): string {
  return (Number(value) || 0).toLocaleString('fa-IR');
}

export function parseResponse<T>(data: T | string): T | null {
  if (typeof data !== 'string') return data;
  try { return JSON.parse(data) as T; } catch { return null; }
}
